import React from 'react';
import styled from 'styled-components';
import {
  Col, Flex, Image, Row,
} from 'antd';
import { colors, fonts } from '../assets/constStyles';
import { ButtonMainYellow } from './button/ButtonMainYellow';
import { membershipOptions } from '../consts';
import { useResizeWidthWindow } from './hook/useResizeWidthWindow';

const IconStyled = styled(Image)`
  height: 70px!important;
  object-fit: cover;
`;

const H3Styled = styled.h3`
  margin-top: 3rem;
  color: ${colors.colorTextWhite};
  text-transform: uppercase;
  text-align: center;
  font-weight: 700;
  font-family: ${fonts.font2};
`;

const PStyled = styled.p`
  text-align: center;
  color: ${colors.colorTextWhite};
  font-family: ${fonts.font2};
  text-transform: uppercase;
  margin: 20px 0;
  font-size: 18px;
  flex-grow: 1;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const DivContentMobStyled = styled.div`
  padding: 50px 20px;
  background-color: ${colors.colorBackground};
`;

const DivVStyled = styled.div`
  padding: 90px;
  z-index: 300;
  position: relative;

     @media (max-width: 768px) {
     padding: 20px;
     }
`;

const DivContainerStyled = styled.div`
   &::after {
     content: '';
     position: absolute;
     inset: 0;
     background: rgba(0, 0, 0, 0.8);
     z-index: 1;
     pointer-events: none;
   }
`;

export const BlockMembership: React.FC = () => (
  useResizeWidthWindow() > 500
    ? (
          <DivContainerStyled style={{
            position: 'relative',
            backgroundImage: 'url(../img/dsc_3969-edited-r-1.jpg)',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }} >

              <DivVStyled>
                    <Row gutter={[24, 24]} align="stretch">
                        {membershipOptions.map((option, index) => (
                            <Col className="gutter-row" xs={24} sm={24} md={12} lg={6} xl={6} key={index}>
                                <Flex vertical align={'center'} justify={'space-between'}
                                      style={{ padding: '0px 12px', height: '100%' }}>
                                    <IconStyled src={`/img/${option.img}`} preview={false}/>
                                    <H3Styled>{option.title}</H3Styled>
                                    <PStyled>{option.description}</PStyled>
                                    <Flex justify={'center'} style={{ marginTop: 'auto' }}>
                                        <ButtonMainYellow text={option.linkText} route={option.link}/>
                                    </Flex>
                                </Flex>
                            </Col>
                        ))}
                    </Row>
              </DivVStyled>
          </DivContainerStyled>
    )
    : (
              <DivContentMobStyled>
                  <Flex gap={50} vertical>
                      {membershipOptions.map((option, index) => (
                          <Flex key={index} vertical align={'center'} justify={'space-between'}
                                style={{ padding: '0px 12px', height: '100%' }}>
                              <IconStyled src={`/img/${option.img}`} preview={false}/>
                              <H3Styled>{option.title}</H3Styled>
                              <PStyled>{option.description}</PStyled>
                              <Flex justify={'center'} style={{ marginTop: 'auto' }}>
                                  <ButtonMainYellow text={option.linkText}/>
                              </Flex>
                          </Flex>
                      ))}
                  </Flex>
              </DivContentMobStyled>
    )
);
